import { classNames } from 'utils/classNames'

type ButtonType = {
  label: string
  clickHandler?: (event: React.MouseEvent<HTMLButtonElement>) => void
  options?: string
}
export const YellowButton = (props: ButtonType): JSX.Element => {
  const { label, clickHandler, options } = props
  const baseStyle =
    'z-100 w-full py-1 rounded whitespace-nowrap text-[#D56B00] font-bold text-sm'
  const colorClass = 'bg-[#FFE9BE] hover:brightness-105'
  return (
    <button
      type={'button'}
      className={classNames([baseStyle, colorClass, options || ''])}
      onClick={clickHandler}
    >
      {label}
    </button>
  )
}
